import { httpClient } from '../http/httpClient'

export const removeTeamMember = async (teamId: string, memberId: string) => {
  const { data } = await httpClient.delete(`team/${teamId}/member/${memberId}`)

  return data
}
